const AUTH_V1_PATH = '/api/v1/auth';

const SPAREMIN_AUTH_PATH = `${AUTH_V1_PATH}/sparemin`;
export const LOGIN_PATH = SPAREMIN_AUTH_PATH;
export const REGISTRATION_PATH = `${SPAREMIN_AUTH_PATH}/register`;
export const FORGOT_PASSWORD_PATH = `${SPAREMIN_AUTH_PATH}/forgot-password`;
export const RESET_PASSWORD_PATH = `${SPAREMIN_AUTH_PATH}/reset-password`;
